<template>
  <div>
    <el-color-picker v-model="theme" :size="size"></el-color-picker>
  </div>
</template>

<script>
const ORIGINAL_THEME = "#409EFF"; // default color
export default {
  name: "ThemePicker",
  props: {
    default: {
      // 初始化主题，可由外部传入
      type: String,
      default: null
    },
    size: {
      // 初始化主题，可由外部传入
      type: String,
      default: "small"
    }
  },
  data() {
    return {
      theme: ORIGINAL_THEME,
      showSuccess: true
    };
  },
  mounted() {
    if (this.default !== null) {
      this.theme = this.default;
      this.$emit("onThemeChange", this.theme);
      this.showSuccess = false;
    }
  },
  watch: {
    theme(val, oldVal) {
      if (typeof val !== "string") return;
      // 响应外部操作
      this.$emit("onThemeChange", val);
      if (this.showSuccess) {
        this.$message({ message: "换肤成功", type: "success" });
      } else {
        this.showSuccess = true;
      }
    }
  },
  methods: {
    // changeTheme(color) {
    //   this.color = color;
    //   this.$store.commit("setThemeColor", color);
    // }
  }
};
</script>

<style lang="scss" scoped>
.theme-picker .el-color-picker__trigger {
  vertical-align: middle;
}

.theme-picker-dropdown .el-color-dropdown__link-btn {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ThemePicker/index.vue